import styled from 'styled-components';

import { IRewardPointCost } from './reward-point-cost';

export const StyledRewardPointCost = styled.span<Omit<IRewardPointCost, 'pointCost'>>`
  text-transform: capitalize;
  font-weight: ${Styles.fontWeight.heavy};
  ${p => p.usePrimaryColor && `color: ${Styles.color.primary}`}
`;
